import React from 'react'
import "./ThankYou.css"
import { Link } from "react-router-dom";

function ThankYou() {
    return (
        <div className="thankyou">
            <Link to="/">
                <img 
                className="thanks__title"
                src="images/Login_logo.png"/>
            </Link>
            <h1>Thank You !</h1>
            <h3>We will contact you soon....</h3>
        </div>
    )
}

export default ThankYou
